import { useLanguage } from '../context/LanguageContext';
import { useUi } from '../i18n/uiTranslations';
import { AnimatedCounter } from './Animations';
import { SceneSection } from './Journey';
import { StaticChip } from './StaticVisuals';
import { scrollToId } from '../lib/gsap';

const STATS = [
  { value: '10K+', labelKey: 'hero.stats.games', animated: true },
  { value: '100+', labelKey: 'hero.stats.providers', animated: true },
  { value: '50+', labelKey: 'hero.stats.markets', animated: true },
  { value: '99.9%', labelKey: 'hero.stats.uptime', animated: false },
];

const RevealLine = ({ children, delay, className = '' }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <span className={`block rise-in ${className}`} style={{ animationDelay: `${delay}s` }}>{children}</span>
  </span>
);

export const HeroSection = ({ onDemoClick }) => {
  const { t } = useLanguage();
  const u = useUi();
  const words = t('hero.title').split(' ');
  const lead = words.slice(0, -2).join(' ');
  const accent = words.slice(-2).join(' ');

  return (
    <SceneSection scene={0} chipControl id="hero" testId="hero-section" span={6} staticVisual={<StaticChip className="w-[min(80vw,calc(var(--band)*0.95))] lg:w-full lg:max-w-[440px] mx-auto" />}>
      <div className="lg:pt-10">
        <p className="eyebrow rise-in" style={{ animationDelay: '0.55s' }}>{u('eyebrow')}</p>
        <h1 className="display-xl mt-6 lg:mt-8 text-[clamp(2.5rem,6vw,6.4rem)] break-words" data-testid="hero-title">
          {lead && <RevealLine delay={0.7}>{lead}</RevealLine>}
          <RevealLine delay={0.85} className="italic metal-text">{accent}</RevealLine>
        </h1>
        <p className="mt-6 lg:mt-8 max-w-[540px] text-base sm:text-lg leading-relaxed text-[#ABA59A] rise-in" style={{ animationDelay: '1s' }} data-testid="hero-subtitle">
          {t('hero.subtitle')}
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-3 sm:gap-4 rise-in" style={{ animationDelay: '1.1s' }}>
          <button onClick={onDemoClick} className="btn-primary min-h-[48px]" data-testid="hero-cta-button">{t('hero.cta')}</button>
          <button onClick={() => scrollToId('experience')} className="btn-secondary min-h-[48px]" data-testid="hero-learn-more">{t('nav.services')}</button>
        </div>
        <dl id="stats" className="mt-14 grid grid-cols-2 sm:grid-cols-4 border-t border-[#F4F0E8]/10 rise-in" style={{ animationDelay: '1.25s' }} data-testid="stats-section">
          {STATS.map((s, i) => (
            <div key={s.labelKey} className={`pt-6 pb-2 pr-3 ${i % 2 ? 'pl-4 border-l border-[#F4F0E8]/10' : ''} ${i === 2 ? 'sm:pl-4 sm:border-l' : ''} ${i > 1 ? 'mt-4 sm:mt-0' : ''}`} data-testid={`hero-stat-${i}`}>
              <dt className="font-display font-light text-[clamp(1.9rem,3vw,2.8rem)] text-[#F4F0E8] leading-none">
                {s.animated ? <AnimatedCounter value={s.value} duration={2.2} /> : s.value}
              </dt>
              <dd className="mt-2 text-xs sm:text-sm text-[#ABA59A]">{t(s.labelKey)}</dd>
            </div>
          ))}
        </dl>
      </div>
    </SceneSection>
  );
};
